import useWindowDimensions from "./useWindowDimensions";

function windowSize(Component) {
    function ComponentWithRouterProp(props) {
        const { width: windowWidth, height: windowHeight } = useWindowDimensions();
        return <Component {...props} windowWidth={windowWidth} windowHeight={windowHeight} />;
    }

    return ComponentWithRouterProp;
}

export default windowSize;
